import Calendar from '../../collection/calendar';
import Filters from '../../view/module/schedule/launch.filters';
import Model from '../../model/model';
import Module from '../../core/module';
import ScheduleForm from './form';
import ScheduleTasksModule from './tasks';
import Stats from '../../collection/schedule/stats';
import ScheduleTemplatesModule from './templates.list';

import { ask } from '../../utils/popups';
import { unixts, datify, } from '../../utils/date';
import { beginLock, endLock } from '../../loader';
import { del, } from '../../http/api';





const 
    OPEN_LAUNCHES_DAILY = 'schedule--open-launches-launches',
    TOGGLE_LIST_VIEW = 'schedule--toggle-list-view',
    TOGGLE_CALENDAR = 'schedule--toggle-calendar';





export default Module.extend( {

    template: 'jst/module.schedule.calendar',

    url() {
        const { schedule, calendar, time } = this.options;

        if (!schedule)
            return `schedule/stats/${calendar.fmt( 'YYYY-MM' )}`;

        return time
            ? `schedule/${schedule.id}/stats/${calendar.fmt( 'YYYY-MM' )}/@/${time.replace( ':', '-' )}`
            : `schedule/${schedule.id}/stats/${calendar.fmt( 'YYYY-MM' )}`;
    },

    open({ scheduleId, time, month, date }) {
        return this.options.scheduleId = scheduleId,
            this.options.calendar = new Calendar( month ),
            this.options.time = time,

            this.setState( { 
                date: unixts( datify( date ) ), 
            } ),

            this.options.stats = new Stats( { calendar: this.options.calendar, } ),
            this.lastFiltering_ = Promise.resolve(),

            this.filtersModel = new Filters.Model( this.state().filters ),
            fetch.call( this ).then( () => 
                this.bind( this.filtersModel ) );
    },

    start() {
        return this;
    },

    stop() {
        return this;
    },

    serialize() {
        const { schedule, calendar, stats } = this.options;

        // todo
        // fetch template task only for orgadmin/orginspector users
        // to check capability to edit this template task
        // templateTaskFetching = roleai.includes( Config.role() )
        //     ? Task.byId( schedule.get( 'template' ).id )
        //     : Promise.resolve();

        return {
            calendar, stats,
            date: this.state().date,
            chosenTime: this.options.time,
            schedule: schedule instanceof Model ? schedule.toJSON() : schedule,
        };
    },

    events: {

        'click .-new-schedule': function({ currentTarget }) {
            this.trigger( ScheduleForm.POPUP_NEW )
        },

        'click .-toggle-list'() {
            this.trigger( TOGGLE_LIST_VIEW, 
                this.options.calendar.getMonth(),
                this.state().date,
                this.state().filters,
                this.options.scheduleId,
                this.options.schedule ? this.options.time : undefined );
        },

        'click .-toggle-daily'() {
            if (this.options.schedule)
                this.trigger( ScheduleTasksModule.REPLACE,
                    // pass id only; schedule will be retrieved by /tasks response
                    this.options.schedule.id,
                    this.options.time,
                    this.options.calendar.getMonth(),
                    this.state().date,
                    this.state().filters );
            else
                this.trigger( OPEN_LAUNCHES_DAILY, 
                    this.options.calendar.getMonth(),
                    this.state().date,
                    this.state().filters );
        },

    },

    [Module.event( 'Filters:change' )](filters) {
        this.setState( { filters, } );

        return fetch.call( this )
            .then( () => this.Calendar.render() )
            .then( () => this.navigated() );
    },

    [Module.event( 'CalendarControls:set-month' )](month) {
        return this.options.calendar.set( month ),
            fetch.call( this )
                .then( () => Promise.all( [this.Calendar.render(), this.CalendarControls.render()] ) )
                .then( () => this.navigated() );
    },

    [Module.event( 'Calendar:date:toggle' )](date) {
        if (this.options.schedule)
            this.trigger( ScheduleTasksModule.REPLACE,
                // pass id only; schedule will be retrieved by /tasks response
                this.options.schedule.id,
                this.options.time,
                this.options.calendar.getMonth(),
                date,
                this.state().filters );
        else
            this.trigger( OPEN_LAUNCHES_DAILY, 
                this.options.calendar.getMonth(),
                date, 
                this.state().filters );
    },

    [Module.event( ':schedule:unpin' )]() {
        this.trigger( TOGGLE_CALENDAR,
            undefined,
            undefined,
            this.options.calendar.getMonth(),
            this.state().date,
            this.state().filters );
    },

    [Module.event( ':schedule:edit' )]({ id }) {
        return this.trigger( ScheduleForm.POPUP_EDIT,
            // pass id only to force Schedule.byId in Form
            id );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        return ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => beginLock( this ) )
            .then( () => fetch.call( this ) )
            .then( () => this.Calendar.render() )
            .then( () => endLock( this ), () => endLock( this ) );
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        this.trigger( ScheduleTemplatesModule.POPUP,
            // pass id only to force Schedule.byId in Template List
            id );
    },

    [Module.event( ':time:toggle')](time) {
        this.options.time = time !== this.options.time ? time : undefined;
        this.setState( { page: 1 } );

        return fetch.call( this )
            .then( () => this.render() )
            .then( () => this.navigated() );
    },

}, {

    OPEN_LAUNCHES_DAILY,

    TOGGLE_LIST_VIEW,

    TOGGLE_CALENDAR,

} );






function fetch() {
    const 
        { stats, scheduleId, time } = this.options,
        filters = this.filtersModel.values();

    if (scheduleId) filters.timetableId = scheduleId;
    if (time) filters.time = time;

    return this.lastFiltering_ = this.lastFiltering_
        .then( () => stats.filter( filters ) )
        .then( ([items, coll, resp]) => {
            this.options.times = resp.times;
            this.options.schedule = resp.schedule;
        } );
};



// WEBPACK FOOTER //
// ./src/js/module/schedule/calendar.js